export const STATUS_DESCRIPTIONS: Record<string, string> = {
  Submitted: 'Logged and awaiting triage',
  Scheduled: 'Opens scheduling dialog',
  Assigned: 'Opens assign dialog',
  'En Route': 'Trade is on the way',
  'On Hold': 'Paused, no action for now',
  'In Progress': 'Work underway',
  'Under Review': 'Awaiting internal review',
  Approved: 'Approved to proceed',
  Declined: 'Opens decline dialog',
  Resolved: 'Work complete, awaiting close',
  Closed: 'Request closed',
  Archive: 'Archives the request',
  Archived: 'Archives the request',
  'One Year Warranty': 'Covered by the 1-year warranty',
};
